import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    root: {},

    title: {
        fontSize: '20px',
    }

}));


export default function Header(props) {
    const { className, agencies, ...rest } = props;
    const classes = useStyles();
    // alert(props)
    return (
        <div {...rest} className={clsx(classes.root, className)} >
            <Grid alignItems="flex-end" container justify="space-between" spacing={3} >
                <Grid item>


                </Grid>
                <Grid item>

                    {/* <Link to="/agency_create_admins"> */}
                    <Button variant="contained" onClick={() => {
                        if(props.agents.length >= 10){
                            alert("You have reached the maximum of 10 admins per agency");
                        }else{
                            props.history.push('/agency_create_admins/' + props.agency_id);
                        }
                    }}>
                        Create New Admin
                        </Button>

                </Grid>
            </Grid>
            <div style={{ marginBottom: "20px" }}></div>
        </div>

    )
}
